import { ServiceOptionItem } from '../../../../ServiceSummary/types';

export const groupByProduct = (items: ServiceOptionItem[]): ServiceOptionItem[][] => {
	const groups = new Map<string, ServiceOptionItem[]>();

	items.forEach(item => {
		const group = groups.get(item.id);

		group ? group.push(item) : groups.set(item.id, [item]);
	});

	return [...groups.values()];
};
